module.exports = __webpack_public_path__ + "assets/img/work-scheme.1160e644.webp";